/* eslint-disable react/jsx-no-target-blank */
// disabling the above eslint rule because we're purposefully leaving the `rel="noreferrer"` off of our link to talentpair.com
import * as React from "react";
import { Link } from "@talentpair/quantic";
import { env } from "@talentpair/env";
import { OrgBoardDetailT } from "../types";

interface FooterProps {
  org: OrgBoardDetailT;
}

export default function Footer({ org }: FooterProps): React.ReactElement {
  return (
    <section className="flex-center grey-border-top" style={{ height: 75 }}>
      <span>
        Powered by{" "}
        <a href="https://www.talentpair.com" target="_blank" className="bold black">
          Talentpair
        </a>{" "}
        -{" "}
        <Link color="primary" href={env.londonUrl("/employer-signin")}>
          {org.name} Log in
        </Link>
      </span>
    </section>
  );
}
